import React from 'react';
import propTypes from 'prop-types';

import { getMessage } from 'util/locale';
// components
import BaseModal from 'common/modals/BaseModal';

const baseString = 'vra-delete-modal';
let DeleteModal = ({
  deleteModal,
  onCancelDeleteModal,
  onSaveDeleteModal,
  scriptId
}) => {

  return deleteModal ? (
    <BaseModal
      onCancel={() => { onCancelDeleteModal(); }}
      onSave={() => { onSaveDeleteModal({ scriptId }); }}
      saveText={getMessage('button-text__delete')}
      shouldCloseOnOverlayClick={false}>
      <div className={`${baseString}`}>
        { getMessage('help-text__delete-prescription') }
      </div>
    </BaseModal>
  ) : null;
};

DeleteModal.propTypes = {
  deleteModal: propTypes.object,
  onCancelDeleteModal: propTypes.func.isRequired,
  onSaveDeleteModal: propTypes.func.isRequired,
  scriptId: propTypes.string
};

export default DeleteModal;